import { Paths } from '../../lib/constants/path'
import { RoleEnum } from '../../lib/types/enums/users/role.enum'
import { Route } from '../../lib/types/routes'
import { CenterPaymentsListPage } from './center-payments-list'

export const centerPaymentsRoutes: Route[] = [
  {
    path: Paths.CENTER_PAYMENTS_LIST_PAGE,
    element: <CenterPaymentsListPage />,
    roles: [RoleEnum.ADMIN]
  }
]
